const customRules = {
  pageName: 'Regras Personalizadas',
  btnCreate: 'Criar',
  form: {
    header: {
      create: {
        title: 'Regras Personalizadas',
      },
      update: {
        title: 'Regras Personalizadas',
      },
    },
    information: {
      details: {
        header: 'Detalhes',
        fields: {
          name: 'Nome',
          type: {
            name: 'Tipo',
            values: {
              tripPriority: 'Prioridade de viagem',
              driverPriority: 'Prioridade do motorista',
              passengerPreferences: 'Preferências de passageiros',
            },
          },
          passengerRuleType: {
            name: 'Tipo de regra',
            options: {
              passengers: 'Passageiros',
              drivers: 'Motoristas',
              vehicles: 'Veículos',
              passengersAndDrivers: 'Passageiro e Motoristas',
            },
          },
          source: {
            name: 'Fonte',
            values: {
              internal: 'Perfis de passageiros',
              integration: 'Reservas de convidados',
            },
          },
        },
      },
      preference: {
        header: 'Preferências',
        fields: {
          passenger: 'Passageiro',
          passengers: 'Passageiros',
          preferenceType: {
            name: 'Tipo de preferência',
            values: {
              rideTogether: 'Viajar juntos',
              rideApart: 'Viajar separados',
              preferredDriver: 'Motorista preferido',
              excludedDriver: 'Motorista excluído',
              strictDriver: 'Motorista estrito',
              preferredVehicle: 'Veículo preferido',
              excludedVehicle: 'Veículo excluído',
            },
          },
          drivers: 'Motoristas',
          driverPreferenceType: {
            name: 'Tipo de preferência',
          },
          vehicleBy: {
            name: 'Veículo por',
            values: {
              makeAndModel: 'Marca / modelo do veículo',
              name: 'Nome do veículo',
            },
          },
          vehicleMake: 'Marca do veículo',
          vehicleModels: 'Modelos de veículo',
          vehicleNames: 'Nomes de veículos',
          frequency: {
            name: 'Frequência',
            values: {
              always: 'Sempre',
              specificRange: 'Intervalo específico',
            },
          },
          dateFrom: 'Data de',
          dateTo: 'Data até',
          timeFrom: 'Hora de',
          timeTo: 'Hora até',
          weekdays: 'Dias da semana',
          direction: {
            name: 'Direção',
            values: {
              both: 'De e para',
              pickup: 'De',
              dropoff: 'Para',
            },
            warningNoLocation: 'Se nenhuma localização for selecionada, escolher “Direção: De/Para” separará automaticamente o Trecho A e o Trecho B.',
          },
          location: 'Localização',
          pickupOrder: {
            name: 'Definir Ordem de Coleta',
          },
        },
        actions: {
          add: '+ Adicionar preferência',
          addPassenger: 'Adicionar',
        },
      },
      priority: {
        header: 'Registro {{count}}',
        recordHeader: 'Registro',
        scoreLabel: 'Pontuação',
        fields: {
          attributes: 'Atributos',
          areas: 'Zonas',
          profiles: 'Perfis',
        },
        btnAddPriority: {
          label: '+ Adicionar registro',
          tooltip: 'Adicionar um novo nível de registro',
        },
      },
    },
    footer: {
      btnSubmit: {
        create: 'Enviar',
        submitAndCreate: 'Enviar e criar',
        update: 'Enviar',
      },
    },
  },
  table: {
    headers: {
      name: 'Nome',
      type: 'Tipo',
      priority: 'Prioridade',
      record: 'Registro',
      value: 'Valor',
      score: 'Pontuação',
      passengerRuleType: 'Tipo de regra',
    },
    filters: {
      recordType: 'Registro',
    },
    actions: {
      delete: {
        header: 'Remover',
        modal: {
          header: 'Excluir regras personalizadas',
          body: 'Você está prestes a excluir {{num}} regras.',
        },
        toast: {
          success: 'Sucesso!',
          error: 'Erro!',
        },
      },
    },
    tabs: {
      tripsRules: 'Regras de viagens',
      driversRules: 'Regras de motoristas',
      passengersRules: 'Preferências de passageiros',
    },
    toolTip: {
      noPermission: 'Ação não permitida: permissão necessária',
    },
  },
  create: {
    toastSuccess: 'Sucesso!',
    toastError: 'Falha',
    toastValidationMessage: 'Por favor, adicione atributos',
    errorConflict: {
      title: 'Conflito de regra de passageiros',
      body: 'Há um conflito com a regra que você está tentando criar. Esses passageiros já estão atribuídos a outra regra para o mesmo intervalo de tempo específico.',
    },
  },
  edit: {
    toastSuccess: 'Sucesso!',
    toastError: 'Falha',
    toastValidationMessage: 'Por favor, adicione atributos',
    errorConflict: {
      title: 'Conflito de regra de passageiros',
      body: 'Há um conflito com a regra que você está tentando atualizar. Esses passageiros já estão atribuídos a outra regra para o mesmo intervalo de tempo específico.',
    },
  },
};

export default customRules;
